export default __webpack_public_path__ + "static/gulp-d353f91dc1750ba973110c20a71641bc.svg";